import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const ChevronLeft = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.85355 3.64645C10.0488 3.84171 10.0488 4.15829 9.85355 4.35355L6.20711 8L9.85355 11.6464C10.0488 11.8417 10.0488 12.1583 9.85355 12.3536C9.65829 12.5488 9.34171 12.5488 9.14645 12.3536L5.14645 8.35355C5.05268 8.25979 5 8.13261 5 8C5 7.86739 5.05268 7.74021 5.14645 7.64645L9.14645 3.64645C9.34171 3.45118 9.65829 3.45118 9.85355 3.64645Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default ChevronLeft
